import { useEffect } from 'react';

/**
 * The public pages are indexed and shared, so each one owns its <title> and
 * meta description. index.html only carries the neutral fallback.
 */
export const useDocumentTitle = (title: string, description?: string): void => {
  useEffect(() => {
    document.title = title;

    if (!description) {
      return;
    }

    const meta =
      document.querySelector<HTMLMetaElement>('meta[name="description"]') ??
      document.head.appendChild(Object.assign(document.createElement('meta'), { name: 'description' }));
    meta.content = description;
  }, [title, description]);
};
